import Vue from "vue";
import App from "./App.vue";

//Utils
import { CustomCSSProperties } from "./utils/cutsomStyles";
import { AddOnTypes, TemplateTypes } from "./utils/addOnTypes";

type TemplateBuilderProps = {
  container: string | null;
  secretKey: string;
  publicApiKey: string;
  platformName?: string | null;
  templateGalleryModal?: boolean;
  createTemplateRoute?: string | null;
  templateBuilderRoute?: string | null;
  olcTemplate?: Record<string, any>;
  designerTemplateQuery?: Record<string, any> | null;
  sandbox?: boolean;
  allowSenderFields?: boolean;
  allowPropertyFields?: boolean;
  excludedFields?: string[] | null;
  designerQueryAmount?: string | number;
  allowedAddOns?: AddOnTypes[] | string[] | null | undefined;
  allowedTemplateSections?: TemplateTypes[] | string[] | null | undefined;
  env?: string;
  restrictedProducts?: number[] | null | undefined;
  disallowedProducts?: string[] | null | undefined;
  propertyOfferCost?: number;
  customPropertyOfferCost?: number;
  gsvCost?: number;
  allowAdditionalPage?: boolean;
  showTemplateTypesPage?: boolean;
  currentTheme?: string | null | undefined;
  onReturnAndNavigate?: () => void;
  onCreateCustomTemplateQuery?: (payload: any) => Promise<any>;
  onGetOneTemplate?: (payload: any) => Promise<any>;
  onGetTemplates?: (payload: any) => Promise<any>;
  onGetCustomFields?: () => Promise<any>;
  onDuplicateTemplate?: (payload: any) => Promise<any>;
  onGetBrandingImages?: (payload: any) => Promise<any>;
  onDeleteBrandingImage?: (id: string | number) => Promise<void>;
  onUploadBrandingImage?: (payload: any) => Promise<any>;
  onGetQRCodes?: (payload: any) => Promise<any>;
  onDeleteQRCodes?: (id: string | number) => Promise<void>;
  onUploadQRCode?: (payload: any) => Promise<any>;
  onEditQRCode?: (payload: any) => Promise<any>;
  onSubmit?: (payload: any) => Promise<any>;
  styles?: {
    root?: CustomCSSProperties;
  };
}

// Function to dynamically load stylesheets based on sandbox mode
const loadStylesheet = (currentTheme: string) => {
  if (currentTheme === 'v2') {
    import('./v2Theme.scss');
  } else {
    import('./index.scss');
  }
};

const TemplateBuilder = ({
  container,
  secretKey,
  publicApiKey,
  platformName,
  templateGalleryModal = true,
  createTemplateRoute,
  templateBuilderRoute,
  olcTemplate,
  designerTemplateQuery,
  sandbox,
  allowSenderFields,
  allowPropertyFields,
  excludedFields,
  designerQueryAmount,
  allowedAddOns,
  allowedTemplateSections,
  env,
  restrictedProducts,
  disallowedProducts,
  propertyOfferCost,
  customPropertyOfferCost,
  gsvCost,
  allowAdditionalPage,
  showTemplateTypesPage,
  currentTheme,
  onReturnAndNavigate,
  onCreateCustomTemplateQuery,
  onGetOneTemplate,
  onGetTemplates,
  onGetCustomFields,
  onDuplicateTemplate,
  onGetBrandingImages,
  onDeleteBrandingImage,
  onUploadBrandingImage,
  onGetQRCodes,
  onDeleteQRCodes,
  onUploadQRCode,
  onEditQRCode,
  onSubmit,
  styles,
}: TemplateBuilderProps) => {
  const props = {
    container,
    secretKey,
    publicApiKey,
    platformName,
    templateGalleryModal,
    createTemplateRoute,
    templateBuilderRoute,
    olcTemplate,
    designerTemplateQuery,
    sandbox,
    allowSenderFields,
    allowPropertyFields,
    excludedFields,
    designerQueryAmount,
    allowedAddOns,
    allowedTemplateSections,
    env,
    restrictedProducts,
    disallowedProducts,
    propertyOfferCost,
    customPropertyOfferCost,
    gsvCost,
    allowAdditionalPage,
    showTemplateTypesPage,
    currentTheme,
    onReturnAndNavigate,
    onCreateCustomTemplateQuery,
    onGetOneTemplate,
    onGetTemplates,
    onGetCustomFields,
    onDuplicateTemplate,
    onGetBrandingImages,
    onDeleteBrandingImage,
    onUploadBrandingImage,
    onGetQRCodes,
    onDeleteQRCodes,
    onUploadQRCode,
    onEditQRCode,
    onSubmit,
    styles,
  };

  // Load appropriate stylesheet based on sandbox mode
  loadStylesheet(currentTheme || 'default');

  const vueInstance = new Vue({
    render: (h) => h(App, { props }),
  }).$mount(`#${container}`);

  return {
    destroy() {
      vueInstance.$destroy();
    },
  };
};

export default TemplateBuilder;